import { ref, computed } from 'vue';
import { positionApi, type Position } from '@/entities/Position';

export function usePositionOptions() {
  const positions = ref<Position[]>([]);
  const isLoading = ref(false);
  const error = ref<string | null>(null);

  const positionOptions = computed(() => {
    return positions.value.map(position => ({
      id: position.id.toString(),
      name: position.name,
    }));
  });

  async function loadPositions() {
    isLoading.value = true;
    error.value = null;

    try {
      const response = await positionApi.getAllPositions({ itemsPerPage: 1000 });
      positions.value = response.data || [];
    } catch (err) {
      error.value = 'Erro ao carregar cargos';
      console.error('Erro ao carregar cargos:', err);
    } finally {
      isLoading.value = false;
    }
  }

  return {
    positions,
    positionOptions,
    isLoading,
    error,
    loadPositions,
  };
}
